<template>
  <div class="auth-full-page h-100-vh">
    <!-- <Content/> -->
    <b-container class="auth-footer-page">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </b-container>

    <Footer/>
    <!-- <notifications/> -->
  </div>
</template>

<script>
// import Navbar from '@/components/Navbar'
// import Content from './Content'
const Footer = () => import('@/pages/Auth/Footer')

export default {
  name: 'general-screen-dashboard',
  components: {
    Footer,
  }
}
</script>
